import { render } from "./lawNotice.vue?vue&type=template&id=11b8eb50&scoped=true"
const script = {}

import "./lawNotice.vue?vue&type=style&index=0&id=11b8eb50&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b8eb50"]])

export default __exports__